<script setup lang="ts">
import { Factoid } from '@/types/main'

type Props = {
  factoid: Factoid
  isCategoryPage?: boolean
}

const props = defineProps<Props>()

const component = computed(() => {
  return props.factoid.url ? resolveComponent('NuxtLink') : 'div'
})
</script>

<template>
  <component
    :is="component"
    :to="factoid.url"
    class="factoid"
    :style="{ backgroundImage: `url(${factoid.image})` }"
  >
    <div class="factoid__text">
      <span class="factoid__title">{{ factoid.title }}</span>

      <div v-if="factoid.description && isCategoryPage" class="factoid__desc">
        {{ factoid.description }}
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>
.factoid {
  position: relative;
  display: block;
  height: 248px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 16px;

  @include media('>=desktop-mini') {
    width: 276px;
    height: 392px;
    border-radius: 25px;
  }

  &__text {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    padding: 24px 20px;

    @include media('>=tablet') {
      padding: 30px 25px;
    }

    @include media('>=desktop-mini') {
      padding: 40px 36px;
    }
  }

  &__title {
    display: block;
    max-width: 200px;
    font-size: 16px;
    font-weight: 900;
    line-height: 19px;
    color: var(--ui-white);

    @include media('>=tablet') {
      font-size: 20px;
    }

    @include media('>=desktop-mini') {
      font-size: 26px;
      line-height: 31px;
    }
  }

  &__desc {
    margin-top: 5px;
    font-size: 12px;
    font-weight: 600;
    line-height: 17px;
    color: var(--ui-white);

    @include media('>=desktop-mini') {
      font-size: 14px;
    }
  }
}
</style>
